export default {
  name: "type",
  in: "query",
  required: false,
  description:
    "Filtration based on type of clothes - even in parts of string in specified localization viz [localization](#localization)",
  schema: {
    type: "string",
    example: "Oblečení obecně"
  }
};
